import React from "react";
import { CardsSc } from "./index.sc";
import { Card } from "react-bootstrap";
const Index = (props: any) => {
  return (
    <CardsSc>
      <Card
        style={{
          backgroundColor: "#c79595",
          color: "#333333",
          height: "100px",
          width: "240px",
          padding: "1rem 2rem",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.35)",
        }}
        onClick={props?.onClick}
      >
        <Card.Title
          style={{ alignSelf: "center", fontSize: "1rem" }}
          className="d-flex justify-center align-items-center c-pointer flex-wrap"
        >
          {props.name}
        </Card.Title>
      </Card>
    </CardsSc>
  );
};

export default Index;
